import { z } from "zod";
import { File, ReviewLink } from "../../../../../schemas";

export const SecondFormSchema = z
  .object({
    screenshot: File.optional(),
    reviewLink: ReviewLink.optional(),
  })
  .refine(
    (data) => {
      return !!data.screenshot || !!data.reviewLink;
    },
    {
      message: "Нужно добавить скриншот или ссылку",
      path: ["screenshot"],
    }
  );
